const createInitialState = () => ({
  user: null,
  role: null,
  tokens: {
    access: null,
    refresh: null,
  },
  isAuthenticated: false,
  status: 'idle',
  sessionRestored: false,
});

export default createInitialState;
